import React, { Component } from 'react';
import glamorous from 'glamorous';
import withPrismJs from '../with-prismjs-hoc';
import { MENU_ENTRIES } from '../constants';

import XmlExamples from './xml-examples';
import EmptyStructures from './empty-structures';

class XmlFormat extends Component {
  render() {
    return (
      <div data-subsection={MENU_ENTRIES.creatingRecallInXmlFormat}>
        <h3>
          STEP 1: CREATING A RECALL IN XML FORMAT
        </h3>
        <div>
          <p>
            XML is the format used to insert, update or delete a recall in the OECD <i>GlobalRecalls</i> portal.
          </p>
          <p>
            This section includes examples of XML files and empty structure templates to use as a reference for creating
            your own import files.
          </p>
          <p>
            The description of the different fields is under the section: <a onClick={e => this.props.onSectionChange(MENU_ENTRIES.fieldsDescription)}>Field descriptions</a>.
          </p>
          <p>
            When saving each file, please ensure the encodage is “UTF-8 without BOM” in your XML or text editor.
          </p>
        </div>
        <br/><br/>
        <XmlExamples/>
        <br/><br/>
        <EmptyStructures/>
      </div>
    );
  }
}

export default withPrismJs(XmlFormat);



// WEBPACK FOOTER //
// ./src/views/static/import-documentation/xml-format/index.js